import useUserSettingMutation from "./useUserSettingMutation";

const useInventoryUsageSetting = () => {
  const { update, isUpdating } = useUserSettingMutation("inventoryUsage");

  return { updateInventoryUsageSetting: update, isUpdating };
};

export default useInventoryUsageSetting;
